"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerWrapper = exports.BannerSubHeading = exports.BannerHeading = exports.BannerContent = exports.BannerAnchorWrapper = exports.BannerAnchor = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var BannerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Bannerstyles__BannerWrapper",
  componentId: "sc-1xlzl51-0"
})(["width:100%;height:12.5rem;@media (max-width:1720px){height:17rem;}display:flex;background:", ";border:", ";"], function (props) {
  return props.theme.banner.background;
}, function (props) {
  return props.theme.banner.border;
});

exports.BannerWrapper = BannerWrapper;

var BannerContent = _styledComponents["default"].div.withConfig({
  displayName: "Bannerstyles__BannerContent",
  componentId: "sc-1xlzl51-1"
})(["width:100%;padding:1.5rem 0 0 2rem;"]);

exports.BannerContent = BannerContent;

var BannerHeading = _styledComponents["default"].p.withConfig({
  displayName: "Bannerstyles__BannerHeading",
  componentId: "sc-1xlzl51-2"
})(["", ";"], function (props) {
  return props.theme.banner.heading;
});

exports.BannerHeading = BannerHeading;

var BannerSubHeading = _styledComponents["default"].p.withConfig({
  displayName: "Bannerstyles__BannerSubHeading",
  componentId: "sc-1xlzl51-3"
})(["", ";"], function (props) {
  return props.theme.banner.subHeading;
});

exports.BannerSubHeading = BannerSubHeading;

var BannerAnchorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Bannerstyles__BannerAnchorWrapper",
  componentId: "sc-1xlzl51-4"
})(["display:flex;margin-left:-5px;"]);

exports.BannerAnchorWrapper = BannerAnchorWrapper;

var BannerAnchor = _styledComponents["default"].a.withConfig({
  displayName: "Bannerstyles__BannerAnchor",
  componentId: "sc-1xlzl51-5"
})(["", ";"], function (props) {
  return props.theme.banner.anchor;
});

exports.BannerAnchor = BannerAnchor;